import styled from 'styled-components';
import BigBgImg from '../../../assets/bg.png'
import {descFont} from '../StyleValue'


const Mainbg = styled.main`
  background-color: #fff;
  font-size: ${descFont}px;
  background: url(${BigBgImg}) no-repeat;
  background-position: 50%;
  background-size: cover;
  margin: auto;
`;

export default Mainbg;